import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Plus, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Filters } from "@/components/Filters";
import { SyncBar } from "@/components/SyncBar";
import { TaskList } from "@/components/TaskList";
import { TaskFormDialog } from "@/components/TaskFormDialog";
import { CompleteDialog } from "@/components/CompleteDialog";
import { api } from "@/lib/api";
import { useQuickCreate } from "@/context/QuickCreate";

export default function AllTasks() {
  const [params] = useSearchParams();
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formOpen, setFormOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [completing, setCompleting] = useState(null);
  const { refreshKey } = useQuickCreate();
  const [filters, setFilters] = useState({
    section: params.get("section") || "all",
    status: params.get("status") || "all",
    priority: "all",
    assignee: "all",
    record_type: params.get("record_type") || "all",
    range: params.get("range") || "all",
  });

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/tasks", { params: filters });
      setTasks(data);
    } finally {
      setLoading(false);
    }
  }, [filters, refreshKey]);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="mx-auto w-full max-w-6xl space-y-6">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h1 className="font-display text-3xl font-bold tracking-tight">Tüm İşler</h1>
          <p className="mt-1 text-sm text-muted-foreground">
            {tasks.length} kayıt · Adliye, TÜRKPATENT ve Diğer birlikte
          </p>
        </div>
        <Button
          onClick={() => { setEditing(null); setFormOpen(true); }}
          data-testid="tasks-create-btn"
          className="bg-crimson text-white hover:bg-crimson/90"
        >
          <Plus className="h-4 w-4" /> Yeni Kayıt
        </Button>
      </div>

      <SyncBar />

      <Filters filters={filters} setFilters={setFilters} />

      {filters.record_type !== "all" && (
        <button
          type="button"
          onClick={() => setFilters((f) => ({ ...f, record_type: "all" }))}
          data-testid="record-type-chip"
          className="inline-flex items-center gap-2 rounded-lg border border-border bg-muted px-3 py-1.5 text-xs font-semibold text-foreground"
        >
          Kayıt türü: {filters.record_type}
          <X className="h-3.5 w-3.5" />
        </button>
      )}

      <TaskList
        tasks={tasks}
        loading={loading}
        onEdit={(t) => { setEditing(t); setFormOpen(true); }}
        onComplete={setCompleting}
        onRefresh={load}
      />

      <TaskFormDialog open={formOpen} onOpenChange={setFormOpen} initial={editing} onSaved={load} />
      <CompleteDialog task={completing} open={!!completing} onOpenChange={(v) => !v && setCompleting(null)} onDone={load} />
    </div>
  );
}
